/**
 * @fileoverview GET handler for the "/apps/get_default_page/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsGetDefaultCustomPagesAppGroupId } from "./constants";
import type { AppsGetDefaultCustomPagesAppGroupIdResult } from "./types";

export const getAppsGetDefaultCustomPagesAppGroupId = reactQueryFetcherAdapter(
  appsGetDefaultCustomPagesAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<AppsGetDefaultCustomPagesAppGroupIdResult> => {
    return fetch(`/apps/get_default_custom_pages/${appGroupId}`, "GET", {}, { signal });
  }
);
